import { UserProfile, ProfileType } from "../User";

export class MockProfile implements UserProfile {
  private static INDEX = 0;
  public userProfile: ProfileType = ProfileType.GENERIC;

  public id: string;
  public avatarId = "1";
  public isMaster = true;
  public isPinLocked = false;
  public nickname = "nickname";

  constructor() {
    MockProfile.INDEX++;
    this.id = `${MockProfile.INDEX}`;
  }
}
